import React from 'react';
import StoreBadge from './StoreBadge';
import styles from './ArbitragePanel.module.css';

export default function ArbitragePanel({ arbitrage, storeMap }) {
  if (!arbitrage.length) return null;

  return (
    <div className={styles.panel}>
      <div className={styles.header}>
        ⚠ Arbitrage opportunities
        <span className={styles.count}>{arbitrage.length} found</span>
      </div>

      {arbitrage.map((arb, i) => (
        <div key={i} className={styles.row}>
          <span className={styles.spread}>+{arb.spread.toFixed(0)}%</span>
          <span className={styles.name} title={arb.name}>
            {arb.name.length > 36 ? arb.name.slice(0, 36) + '…' : arb.name}
          </span>
          <StoreBadge store={storeMap[arb.cheapest.store]} />
          <span className={styles.prices}>
            ${arb.cheapest.price.toFixed(2)} → ${arb.priciest.price.toFixed(2)}
          </span>
          <span className={styles.save}>Save ${arb.saving.toFixed(2)}</span>
        </div>
      ))}
    </div>
  );
}
